
import { Component, Vue } from 'vue-property-decorator'

import BacModal from '@/components/BacModal.vue'
import BacButton from '@/components/BacButton.vue'

@Component({
  components: {
    BacModal,
    BacButton
  }
})
export default class ExportOrderCsv extends Vue {
  startDate = ''
  endDate = ''
  notExported = []

  async downloadCSV () {
    if (!this.startDate || !this.endDate) {
      alert('Bitte korrektes Start und Enddatum auswählen!')
      return
    }
    this.getNotExported()
    window.open(`/api/order/export/${this.startDate}/${this.endDate}/quahReJ6`)
  }

  async getNotExported () {
    const data = await (await fetch(`/api/order/not-exported/${this.startDate}/${this.endDate}/quahReJ6`)).json()
    this.notExported = data
  }
}

